// extracted by mini-css-extract-plugin
export default {"bookmarkButton":"BookmarkButton_bookmarkButton__qF3uE","bookmarked":"BookmarkButton_bookmarked__xFvMh"};